import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const items = [
  {
    title: 'Presencia mensual en programas ancla',
    text: 'Entrevistas o segmentos en TNO Business y Franquicias en Venezuela (según calendario editorial), con narrativa de oportunidad, escalabilidad y crecimiento para la red Chemical.',
  },
  {
    title: '12 spots diarios (20 s)',
    text: 'Rotativa en la señal: frecuencia para recordación y respuesta.',
  },
  {
    title: '4 artículos SEO en TNO Digest (siempre al mes)',
    text: 'Cuatro piezas mensuales fijas: inversión, emprendimiento, red Chemical y CTA a WhatsApp para solicitar plan de distribuidor. No es variable: son 4 artículos todos los meses.',
  },
  {
    title: '1 Reel estilo «pitch»',
    text: 'Formato dinámico tipo «Shark Tank»: invitar a emprender con Chemical, en tono cercano y profesional.',
  },
];

const DeliverablesChemical = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Inversión mensual
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        $400
      </Typography>
      <Typography variant="body1" color="textSecondary" align="center" paragraph sx={{ maxWidth: 640, mx: 'auto' }}>
        Paquete integrado para reclutamiento y autoridad de marca. Incluye:
      </Typography>
      <Grid container spacing={2}>
        {items.map((item, i) => (
          <Grid item xs={12} sm={6} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
            >
              <Typography variant="subtitle1" fontWeight={700} color="primary" gutterBottom>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default DeliverablesChemical;
